export class UrlsUtils {

    static admin_domains = [
        'admin.startupitalia.eu',
        'smartmoney-admin.startupitalia.eu',
        'ischool-admin.startupitalia.eu',
        'thenexttech-admin.startupitalia.eu',
        'thefoodmakers-admin.startupitalia.eu',
        'openinnovation-admin.startupitalia.eu',
        'cybersecurity-admin.startupitalia.eu',
        'impact-admin.startupitalia.eu',
        'sportup-admin.startupitalia.eu',
        'smartworking-admin.startupitalia.eu',
        'valoreresponsabile-admin.startupitalia.eu',
        'life-admin.startupitalia.eu',
    ]

    static old_domains = [
        'startupitalia.eu',
        'smartmoney.startupitalia.eu',
        'ischool.startupitalia.eu',
        'thenexttech.startupitalia.eu',
        'thefoodmakers.startupitalia.eu',
        'openinnovation.startupitalia.eu',
        'cybersecurity.startupitalia.eu',
        'impact.startupitalia.eu',
        'sportup.startupitalia.eu',
        'smartworking.startupitalia.eu',
        'valoreresponsabile.startupitalia.eu',
        'life.startupitalia.eu',
    ]

    static ensure_wp_content(url) {
        // url = "asdasda"
        // if ()
        // var regStrContent2 = 'http[s]*:\/\/(?!cdn)[a-z0-9A-Z.-]*startupitalia.eu\/wp-content\/';
        // var regContent = new RegExp(regStrContent,'g');
        if (url === undefined || url === null || url === ""){
            return url;
        }

        let regContent;
        regContent = new RegExp(
            "href='#' data-downloadurl=",
            'g'
        );
        url = url.replace(regContent, 'target="_blank" href=');

        // regContent = new RegExp(
        //     'src="/',
        //     'g'
        // );
        // url = url.replace(regContent, 'src="https://startupitalia.eu/');

        // regContent = new RegExp(
        //     'href="/',
        //     'g'
        // );
        // url = url.replace(regContent, 'href="https://startupitalia.eu/');

        // regContent = new RegExp(
        //     "src='/",
        //     'g'
        // );
        // url = url.replace(regContent, "src='https://startupitalia.eu/");

        // regContent = new RegExp(
        //     "href='/",
        //     'g'
        // );
        // url = url.replace(regContent, "href='https://startupitalia.eu/");

        regContent = new RegExp(
            'http[s]*://(?!cdn)[a-z0-9A-Z.-]*startupitalia.eu/wp-content/',
            'g'
        );
        url = url.replace(regContent, 'https://cdn.startupitalia.eu/wp-content/');

        regContent = new RegExp(
            'http[s]*://(?!cdn)[a-z0-9A-Z.-]*startupitalia.eu/download/',
            'g'
        );
        url = url.replace(regContent, 'https://cdn.startupitalia.eu/download/');

        return url;
    }

    static ensure_wp_admin_url(text) {
        if (text === undefined || text === null || text === ""){
            return text;
        }

        let regex_text = "(https://|http://|//)(" +
            this.admin_domains.concat(this.old_domains).join('|') +
        ")/";

        var reg = new RegExp(regex_text, "g");
        text = text.replace(reg, '/');
        return text;
    }
}
